import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reservationApi } from '@/api/reservations';

/**
 * React Query mutation hook to confirm a reservation
 */
export function useConfirmReservation(storeDomain: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reservationUuid: string) => {
      if (!storeDomain) {
        throw new Error('Store domain is required');
      }
      return reservationApi.confirmReservation(storeDomain, reservationUuid);
    },
    onSuccess: (_data, reservationUuid) => {
      queryClient.invalidateQueries({
        queryKey: ['reservation', storeDomain, reservationUuid],
      });
    },
    retry: false,
  });
}
